import { MapView } from '../components/map/MapView';
import { TrafficSignalDot } from '../components/map/TrafficSignalDot';
import {
  santaColomaSignals,
  SANTA_COLOMA_CENTER,
  SANTA_COLOMA_BOUNDS,
  SANTA_COLOMA_ZOOM,
} from '../data/santa-coloma';

export function SantaColomaMapView() {
  return (
    <div className="relative w-full h-full">
      <div className="absolute inset-0 map-container">
        <MapView
          center={SANTA_COLOMA_CENTER}
          zoom={SANTA_COLOMA_ZOOM}
          bearing={0}
          pitch={0}
          maxBounds={SANTA_COLOMA_BOUNDS}
          minZoom={13}
          maxZoom={19}
        >
          {santaColomaSignals.map(signal => (
            <TrafficSignalDot key={signal.id} signal={signal} />
          ))}
        </MapView>
      </div>

      {/* Panel informativo */}
      <div className="absolute top-3 left-3 bg-gray-900/90 backdrop-blur-sm rounded-lg border border-gray-700 px-3 py-2 text-xs text-gray-300 z-40">
        <span className="font-medium text-white">Santa Coloma de Gramenet</span>
        <span className="mx-1.5 text-gray-600">·</span>
        {santaColomaSignals.length} semáforos
        <span className="mx-1.5 text-gray-600">·</span>
        <span className="text-gray-500">Fuente: OSM</span>
      </div>
    </div>
  );
}
